import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TechnologyType } from '@/features/projects/types';

export function useTechnologies() {
  const { t } = useTranslation(['technologies']);

  const filters = useMemo(
    () => [
      { label: t(`Solar PV`), value: 'solar' as TechnologyType, icon: 'solar' },
      { label: t(`Wind`), value: 'wind' as TechnologyType, icon: 'wind' },
      { label: t(`BESS`), value: 'bess' as TechnologyType, icon: 'bess' },
      { label: t(`Biogas`), value: 'biogas' as TechnologyType, icon: 'biogas' },
      { label: t(`Hydrogen`), value: 'hydrogen' as TechnologyType, icon: 'hydrogen' },
      { label: t(`Hydropower`), value: 'hidropower' as TechnologyType, icon: 'hidropower' },
      { label: t(`Data Center`), value: 'datacenter' as TechnologyType, icon: 'datacenter' },
      { label: t(`TopCo`), value: 'topco' as TechnologyType, icon: 'topco' },
    ],
    [t]
  );

  const kv = useMemo(
    () =>
      filters.reduce((map, option) => ({ ...map, [option.value]: option.label }), {}) as Record<TechnologyType, string>,
    [filters]
  );

  const map = useCallback((value: TechnologyType) => kv[value], [kv]);

  return { filters, kv, map };
}
